<template>
  <div class="vertical-drag" :class="{ summary: summary }">
    <div v-if="!summary" class="cont-tit">
      <h6>{{currentBranch.name}}</h6>
    </div>
    <div class="address">
      <div v-if="!summary" class="tit">
        <i class="icon icon-location" />
        {{$t("MHLP-04-01-02-04")}}<!--주소-->
      </div>
      {{currentBranch.address}}
    </div>
    <div v-if="!summary" class="tel">
      <div class="tit">
        <i class="icon icon-location-call" />
        {{$t("MHLP-04-01-02-05")}}<!-- 전화-->
      </div>
      {{currentBranch.telephone}}
    </div>
  </div>
</template>
<script>
export default {
  name: "verticalscroll",
  props: {
    summary: { type: Boolean, default: false },
    currentBranch:{type:Object}
  },
  data() {
    return {};
  },
};
</script>
